export const HUBDATA_REFRESH = 'hubManagment/data_refresh';
export const hubDataRefresh = data => ({
  type: HUBDATA_REFRESH,
  payload: data
});

export const HUBDATA_FETCH = 'hubManagment/data_fetch';
export const hubDataFetch = data => ({
  type: HUBDATA_FETCH,
  payload: data
});

export const HUBDATA_GET_SUCCESS = 'hubManagment/data_get_success';
export const hubDataGetSuccess = data => ({
  type: HUBDATA_GET_SUCCESS,
  payload: data
});

export const HUBDATA_RESET = 'hubManagment/reset';
export const hubDataReset = () => ({
  type: HUBDATA_RESET
});
